import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'src/components/common/Form/Select';
import { Mode } from 'src/types/crudTable';
import { useTableContext } from './useTableContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var BulkUpdateSelect = function BulkUpdateSelect(_ref) {
  var _meta$bulkUpdate;

  var column = _ref.column,
      isDisabled = _ref.isDisabled;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(),
      value = _useState[0],
      setValue = _useState[1];

  var _useTableContext = useTableContext(),
      table = _useTableContext.table,
      bulkUpdate = _useTableContext.bulkUpdate,
      mode = _useTableContext.mode;

  var meta = column.columnDef.meta;

  if ((_meta$bulkUpdate = meta.bulkUpdate) !== null && _meta$bulkUpdate !== void 0 && _meta$bulkUpdate.isMulti) {
    return /*#__PURE__*/_jsx(Select, {
      className: "w-full",
      placeholder: t('common:table.bulkUpdate', '批次更新'),
      options: meta.bulkUpdate.options,
      value: meta.bulkUpdate.options.filter(function (option) {
        return value === null || value === void 0 ? void 0 : value.includes(option.value);
      }),
      onChange: function onChange(options) {
        setValue(options.map(function (option) {
          return option.value;
        }));
        bulkUpdate(column.id, options.map(function (option) {
          return option.value;
        }));
      },
      isMulti: true,
      isClearable: false,
      closeMenuOnSelect: false,
      isDisabled: !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected() || mode !== Mode.EDIT || isDisabled,
      showTooltip: true,
      e2eid: "CrudTable_BulkUpdater_Select"
    });
  }

  return /*#__PURE__*/_jsx(Select, {
    options: meta.bulkUpdate.options,
    placeholder: t('common:table.bulkUpdate', '批次更新'),
    className: "w-full",
    value: "",
    onChange: function onChange(_ref2) {
      var value = _ref2.value;
      return bulkUpdate(column.id, value);
    },
    isDisabled: !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected() || mode !== Mode.EDIT || isDisabled,
    e2eid: "CrudTable_BulkUpdater_Select_1"
  });
};